import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import moment from "moment";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { graphql, compose } from "react-apollo";
import { SortableContainer, arrayMove } from "react-sortable-hoc";
import { queryGetLabelsByType, mutationUpdateLabelTemplate } from "Apollo";
import { ShowNotice } from "Store";
import AddButton from "../common/AddButton";
import Row from "./RowWithMutation";
import AddLabelModal from "./AddLabelModalWithMutation";

const Container = SortableContainer(({ labels, refetch }) => {
  return (
    <div>
      {labels.map((label, index) => (
        <Row
          key={`item-${index}`}
          index={index}
          id={label.id}
          label={label.name}
          color={"#" + label.color}
          show={label.isShown}
          refetch={refetch}
        />
      ))}
    </div>
  );
});

export default compose(
  graphql(queryGetLabelsByType),
  graphql(mutationUpdateLabelTemplate)
)(
  observer(
    class List extends Component {
      static propTypes = {
        title: PropTypes.string,
        type: PropTypes.string
      };
      states = observable({ showModal: false, labels: [] });

      componentWillReceiveProps(nextProps) {
        const {
          data: { getLabelTemplates: labels }
        } = nextProps;
        if (labels) {
          this.states.labels = this.sortLabels(labels);
        }
      }

      render() {
        const { showModal, labels } = this.states;
        const {
          title,
          type,
          data: { refetch }
        } = this.props;

        return (
          <Wrapper>
            <Header>
              <Title>{title}</Title>
              <AddButton onClick={this.showModal}>+ Add New Label</AddButton>
            </Header>
            <Container
              useDragHandle={true}
              labels={labels}
              refetch={refetch}
              onSortEnd={this.onSortEnd}
            />
            {showModal && (
              <AddLabelModal
                labelType={type}
                refetch={refetch}
                onCancel={this.hideModal}
                onConfirm={this.hideModal}
              />
            )}
          </Wrapper>
        );
      }

      sortLabels = labels => {
        let newLabels = [];
        if (labels) {
          newLabels = labels.slice();
          newLabels.sort((a, b) => {
            if (a.order !== b.order) {
              return a.order > b.order;
            } else {
              return moment(a.dateCreated).isAfter(b.dateCreated);
            }
          });
        }
        return newLabels;
      };

      hideModal = () => {
        this.states.showModal = false;
      };

      showModal = () => {
        this.states.showModal = true;
      };

      // call when sort has ended
      onSortEnd = async ({ oldIndex, newIndex }) => {
        const {
          mutate,
          data: { refetch }
        } = this.props;
        const { labels } = this.states;

        // using thirdparty sort function
        this.states.labels = arrayMove(labels, oldIndex, newIndex);

        // match backend format
        const sortedLabels = [];
        for (let i = 0; i < this.states.labels.length; i++) {
          sortedLabels[i] = { id: this.states.labels[i].id, order: i };
        }

        // then send to backend
        try {
          await mutate({
            variables: {
              labels: sortedLabels
            }
          });
          refetch();
          ShowNotice("label-template-sort-success");
        } catch (error) {
          ShowNotice("label-template-sort-error");
        }
      };
    }
  )
);

const Wrapper = styled.div`
  width: 280px;
  &:not(:first-child):not(:last-child) {
    margin: 0 20px;
  }
`;
const Header = styled.div`
  display: flex;
  flex: none;
  height: 35px;
  background-color: ${props => props.theme.supervisorPanelHeader};
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  margin-bottom: 12px;
`;
const Title = styled.span`
  color: white;
  font-size: 1rem;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/label-panel/ListWithQueryMutation.js